import { QueryClient, MutationCache, QueryCache, defaultShouldDehydrateQuery, isServer } from "@tanstack/react-query";
import { globalErrorHandler, defaultOptions, mutationErrorHandler, queryErrorHandler } from "./config.js";
import { RETRIES_COUNT } from "./constants/config.js";
let browserQueryClient = void 0;
const makeQueryClient = () => new QueryClient({
  defaultOptions: {
    queries: {
      ...defaultOptions
    },
    mutations: {
      retry: RETRIES_COUNT,
      onError: globalErrorHandler
    },
    dehydrate: {
      // include pending queries in dehydration
      shouldDehydrateQuery: (query) => defaultShouldDehydrateQuery(query) || query.state.status === "pending",
      // We should not catch Next.js server errors
      // as that's how Next.js detects dynamic pages
      // so we cannot redact them.
      // Next.js also automatically redacts errors for us
      // with better digests.
      shouldRedactErrors: () => false
    }
  },
  queryCache: new QueryCache({
    onError: queryErrorHandler
  }),
  mutationCache: new MutationCache({
    onError: mutationErrorHandler
  })
});
function getQueryClient() {
  if (isServer) {
    return makeQueryClient();
  } else {
    if (!browserQueryClient) browserQueryClient = makeQueryClient();
    return browserQueryClient;
  }
}
export {
  getQueryClient,
  makeQueryClient
};
